export default __webpack_public_path__ + "static/media/icon.661c0107.png";